import script from "./TextMode.vue?vue&type=script&setup=true&lang=js"
export * from "./TextMode.vue?vue&type=script&setup=true&lang=js"

import "./TextMode.vue?vue&type=style&index=0&id=9e23c44c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e23c44c"]])

export default __exports__